import { QueryClient } from "@tanstack/react-query";
import { AxiosError, HttpStatusCode } from "axios";

/**
 * Centralized React Query client for the common package.
 * This ensures all components and hooks use the same query cache.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry(failureCount, error) {
        if (error instanceof AxiosError) {
          if (!error.response) {
            return failureCount < 2;
          }

          return (
            ![401, 404].includes(error.response.status) && failureCount < 2
          );
        }
        return failureCount < 2;
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 1000 * 60 * 60, // 1 hour,
    },
    mutations: {
      retry(failureCount, error) {
        if (
          error instanceof AxiosError &&
          error.response?.status === HttpStatusCode.TooManyRequests
        ) {
          return false;
        }
        return failureCount < 1;
      },
    },
  },
});
